<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    created() {},
};
</script>

<style lang="scss">
@import url("//at.alicdn.com/t/font_1596855_684nilpdn2t.css");
#app {
    font-family: initial;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    min-width: 1200px;
}

* {
    box-sizing: border-box;
}
</style>
